import { Component, OnInit, AfterViewInit } from '@angular/core';
import { AuthService } from 'angularx-social-login';
import { FacebookLoginProvider, GoogleLoginProvider, LinkedInLoginProvider } from 'angularx-social-login';
import { SocialUser } from 'angularx-social-login';

declare var $: any;

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignupComponent implements OnInit, AfterViewInit {

  user: SocialUser;
  loggedIn: boolean;

   constructor(private authService: AuthService) { }
   signInWithGoogle(): void {
     this.authService.signIn(GoogleLoginProvider.PROVIDER_ID);
   }

   signInWithFB(): void {
     this.authService.signIn(FacebookLoginProvider.PROVIDER_ID);
   }
   signInWithLinkedIn(): void {
     this.authService.signIn(LinkedInLoginProvider.PROVIDER_ID);
   }

   signOut(): void {
     this.authService.signOut();
   }

   ngOnInit() {
     this.authService.authState.subscribe((user) => {
       this.user = user;
       this.loggedIn = (user != null);
     });
   }

   ngAfterViewInit () {
     $('.dropdown-trigger').dropdown({
       inDuration: 300,
       outDuration: 225,
       constrainWidth: false, // Does not change width of dropdown to that of the activator
       hover: false, // Activate on hover
       gutter: 0, // Spacing from edge
       coverTrigger: false, // Displays dropdown below the button
       alignment: 'left', // Displays dropdown with edge aligned to the left of button
       stopPropagation: false, // Stops event propagation
     });
     $(document).ready(function() {
       $('.collapsible').collapsible();
     });

   }

}
